import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape, availabilityShape } from '@bibliocommons/bc-prop-types';
import ConnectedLibraryHoldAvailability from './ConnectedLibraryHoldAvailability';
import './ConnectedLibraryPanel.scss';

export class ConnectedLibraryPanel extends React.PureComponent {
  render() {
    const probesCount = this.props.probes && this.props.probes.size;
    const showProbesOnBib = this.props.currentLibrary.get('showProbesOnBib');
    if (showProbesOnBib && probesCount > 0) {
      return (
        <div className="cp-connected-library-panel">
          <div className="connected-library-panel__text">
            <FormattedMessage id="circ_also_available" />
          </div>
          {this.props.probes.map(probe => (
            <ConnectedLibraryHoldAvailability
              bibUrl={probe.get('bibUrl')}
              library={this.props.libraries.get(probe.get('libraryId').toString())}
              availability={this.props.availabilities.get(probe.get('metadataId'))}
              key={probe.get('libraryId')}
            />
          ))}
        </div>
      );
    }

    return null;
  }
}

ConnectedLibraryPanel.propTypes = {
  probes: ImmutablePropTypes.list,
  libraries: ImmutablePropTypes.mapOf(libraryShape).isRequired,
  availabilities: ImmutablePropTypes.mapOf(availabilityShape).isRequired,
  currentLibrary: libraryShape.isRequired
};

export default ConnectedLibraryPanel;
